import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import emptyImage from "../../assets/images/empty.jpg"
import "./ProjectsInDraftList.scss"
import LoadingProgressBarGif from "../../assets/images/loading-progressbar.gif"

// start import for materialUI
import LoginInDialog from '../Login/LoginInDialog'
// end import for materialUI

import AlertDialog from "./../GeneralComponents/AlertDialog"
import Axios from 'middleware/axiosInstance'


const ProjectsInDraftList = () => {

    // check if authentication is expired
    const [authenticationIsExpired, setAuthenticationIsExpired] = useState(false);

    // start materialUI
    // const Transition = React.forwardRef(function Transition(props, ref) {
    //     return <Slide direction="up" ref={ref} {...props} />;
    // });
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };
    // end materialUI 

    const navigate = useNavigate();

    const [inProccess, setInProccess] = useState(false)

    const [allProjects, setAllProjects] = useState(
        localStorage.getItem('all-saved-projects-in-storage') == null ?
            [] : JSON.parse(localStorage.getItem('all-saved-projects-in-storage'))
    )
    const apiToken = useState(localStorage.getItem('token'))

    const deleteProject = (indexInArray) => {
        allProjects.splice(indexInArray, 1)
        localStorage.setItem('all-saved-projects-in-storage', JSON.stringify(allProjects))
        setAllProjects(JSON.parse(localStorage.getItem('all-saved-projects-in-storage')))
        // close Dialog Box
        handleClose()
    }

    useEffect(() => {
        setAllProjects(localStorage.getItem('all-saved-projects-in-storage') == null ?

            [] : JSON.parse(localStorage.getItem('all-saved-projects-in-storage')))

    }, []);

    const sendReportToServer = async (project, index) => {
        setInProccess(true)
        // fresh token, if it expired
        project.reportProject.api_token = apiToken
        // project.reportItems.api_token = apiToken
        try {
            const apiRoute = `setitems/projreport`
            const config = {
                headers: {
                    'accept': 'application/json',
                }
            }
            await Axios.post(apiRoute, project.reportProject, config)
                .then(async (res) => {
                    // // alert(res.data.message)
                    // const apiRoute = `set/items/report/${res.data.report_id}`
                    // await Axios.post(`${apiRoute}`, project.reportItems, config)

                    await setInProccess(false)
                    await deleteProject(index)
                    alert(res.data.message)
                    //     })
                }
                )
        }
        catch (error) {
            // console.error(error.response.data);
            setInProccess(false)
            error.response.status === 401 ? setAuthenticationIsExpired(true) : alert("عملیات انجام نشد!")
            navigate("/projects");
        }
    }

    return (
        <div className="main-container-With-tabbar d-flex align-items-center flex-column mb-5">
            {allProjects.length > 0 ? allProjects.map((project, index) => {
                return (
                    project && <div className="project-container mt-2" key={index}>
                        <ul>
                            <li>
                                <span>
                                    نام پروژه:
                                </span>
                                <span>
                                    {project.projectInfo.employerName}
                                </span>
                            </li>
                            <li>
                                <span>
                                    تاریخ ایجاد گزارش:
                                </span>
                                <span style={{ direction: "ltr" }}>
                                    {project.projectInfo.dateDraftCreated}
                                </span>
                            </li>
                        </ul>
                        <div className="d-flex justify-content-around">
                            {inProccess
                                ?
                                <div className="inprogressbar-container">
                                    <img className="inprogressbar-image" src={LoadingProgressBarGif} alt="inprogress-bar" />
                                </div> :
                                <>
                                    {/* <button disabled={inProccess} className="custom-button m-3"
                                        onClick={() => sendReportToServer(project, index)}>
                                        {inProccess ? "درحال ارسال گزارش" : "ارسال گزارش"}
                                    </button> */}

                                    <button
                                        disabled={inProccess} className="m-3 custom-button-danger" onClick={() => setOpen(index)}>حذف گزارش</button>

                                    <button disabled={inProccess} className="m-3 custom-button-green"
                                        onClick={() => sendReportToServer(project, index)}>
                                        {inProccess ? "درحال ارسال گزارش" : "ارسال گزارش"}
                                    </button>
                                </>}
                        </div>
                        {open === index ?
                            <AlertDialog
                                showAlert="true"
                                title={`حذف گزارش پروژه ${project.projectInfo.employerName}`}
                                description={`آیا گزارش پروژه  "${project.projectInfo.employerName}"که در تاریخ "${project.projectInfo.dateDraftCreated}" ایجاد شده حذف شود؟`}
                                acceptButtonText="حذف"
                                rejectButtonText="انصراف"
                                acceptButtonFunction={() => deleteProject(index)}
                                rejectButtonFunction={() => handleClose()}
                            />
                            : null}
                    </div>
                )
            }) :
                <div className="empty-container ">
                    <p className="empty-text">
                        پروژه ای برای ارسال وجود ندارد
                    </p>
                    <img className="empty-image" src={emptyImage} alt="no-project" />
                </div>
            }
            {authenticationIsExpired && < LoginInDialog />}

        </div>
    )
}
export default ProjectsInDraftList